module.exports = __webpack_public_path__ + "static/media/sale.774e4971.jpg";